import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { User,User2 } from '../models/auth.models';
import { ApiserviceService } from './apiservice.service';

@Injectable({ providedIn: 'root' })
export class AuthfakeauthenticationService {
    private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;
  
    personelstorage=[];
    birimadi:string;
    constructor(private http: HttpClient,private api:ApiserviceService) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('kullanici')));
        this.currentUser = this.currentUserSubject.asObservable();

  

    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }
 



login(email: string, password: string) {
    return this.api.post('kanadmin/login', { email, password })
        .then(data => {
      

            // PHP tarafı $this->json->response(data, message, 200) döndürdüğü için:
            // res.data bir dizidir ve içi doluysa giriş başarılıdır.
            if (data && data.status === 200) {
                
                // Genelde ilk kullanıcıyı (res.data[0]) saklamak daha mantıklıdır
                const userData = data.data; // PHP'den gelen veri doğrudan kullanıcı objesi

                // localStorage'a kaydet
                localStorage.setItem('kullanici', JSON.stringify(userData));
                
                // Subject'i güncelle (Uygulama genelinde oturum bilgisini yayar)
                this.currentUserSubject.next(userData);

                return userData;
            } else {
                // Giriş başarısızsa veya kullanıcı bulunamadıysa
                console.error("Giriş bilgileri hatalı");
                return null;
            }
        })
        .catch(err => {
            console.error("Bağlantı hatası:", err);
            throw err;
        });
}

    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('kullanici');
        localStorage.removeItem('kurumu');
        this.currentUserSubject.next(null);
    }
 
   
   
   
   
}
